/**
 * @generated SignedSource<<e2f33359a9fbeab09ad1a73800707ee9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type PipelineRunPageJobAgentCompatibilityStatusFragment$data = {
  readonly attributes: {
    readonly entry: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly value: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly id: number | null | undefined;
  readonly pipelineRunJob: {
    readonly id: string | null | undefined;
  } | null | undefined;
  readonly state: BuildState | null | undefined;
  readonly waitReason: string | null | undefined;
  readonly " $fragmentType": "PipelineRunPageJobAgentCompatibilityStatusFragment";
};
export type PipelineRunPageJobAgentCompatibilityStatusFragment$key = {
  readonly " $data"?: PipelineRunPageJobAgentCompatibilityStatusFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineRunPageJobAgentCompatibilityStatusFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineRunPageJobAgentCompatibilityStatusFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "locator",
          "value": "name:teamcity.pipeline.job.id"
        }
      ],
      "concreteType": "Entries",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Entry",
          "kind": "LinkedField",
          "name": "entry",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "attributes(locator:\"name:teamcity.pipeline.job.id\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PipelineRunJob",
      "kind": "LinkedField",
      "name": "pipelineRunJob",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};
})();

(node as any).hash = "936c05d58e68663159fe86c8c936d38c";

export default node;
